import * as React from 'react';
import { Badge, BadgeHighlight, BadgeStatus, SkeletonLoader } from '@repo/design-system-kit';

export function Loader(): React.JSX.Element {
  return <SkeletonLoader.Block height="24px" width="80px" />;
}

export type TraitName =
  | 'active'
  | 'popular'
  | 'free_trial'
  | 'recommended'
  | 'promo'
  | 'preselected';
interface ProductBadgeProps {
  traits: { name: TraitName; title: string }[];
  className?: string;
}

export type BadgeType = TraitName | null;

export function getBadgeType(traits: { name: TraitName; title: string }[]): {
  type: BadgeType;
  trait: { name: TraitName; title: string } | null;
} {
  const active = traits.find(trait => trait.name === 'active');
  if (active !== undefined) {
    return { type: 'active', trait: active };
  }
  const promo = traits.find(trait => trait.name === 'promo');
  if (promo !== undefined) {
    return { type: 'promo', trait: promo };
  }
  const preselected = traits.find(trait => trait.name === 'preselected');
  if (preselected !== undefined) {
    return { type: 'preselected', trait: preselected };
  }
  const recommended = traits.find(trait => trait.name === 'recommended');
  if (recommended !== undefined) {
    return { type: 'recommended', trait: recommended };
  }
  const popular = traits.find(trait => trait.name === 'popular');
  if (popular !== undefined) {
    return { type: 'popular', trait: popular };
  }
  const freeTrial = traits.find(trait => trait.name === 'free_trial');
  if (freeTrial !== undefined) {
    return { type: 'free_trial', trait: freeTrial };
  }
  return { type: null, trait: null };
}

export function ProductBadge({ className, traits }: ProductBadgeProps): React.JSX.Element | null {
  const { type, trait } = getBadgeType(traits);

  if (!trait) return null;

  // oxlint-disable-next-line typescript/switch-exhaustiveness-check
  switch (type) {
    case 'active':
      return <BadgeStatus className={className} level="validated" text={trait.title} />;
    case 'recommended':
    case 'popular':
    case 'preselected':
      return <BadgeHighlight text={trait.title} />;
    case 'free_trial':
      return <Badge className={className} text={trait.title} type="tryForFree" />;
    case 'promo':
      return <Badge className={className} text={trait.title} type="limitedTime" />;
    default:
      return null;
  }
}
